// extracted by mini-css-extract-plugin
export default {"desktop":"desktop","lcpFixer":"Y9K96J5O","mobile":"mobile"};